let sound: HTMLAudioElement | null = null

// Получить звук получения нового сообщения в чате.
export function getMessageReceivedSound(): HTMLAudioElement {
    if (!sound) {
        sound = new Audio('/img/notification.mp3')
        sound.loop = false
        sound.autoplay = false
        sound.volume = 0.3
    }
    return sound
}

// Запуск звука нового сообщения, если он готов к новому проигрыванию.
export function playMessageReceivedSoundIfNotPlaying() {
    const sound = getMessageReceivedSound()
    if (
        sound.currentTime === 0
        || sound.currentTime === sound.duration
    ) {
        sound.currentTime = 0
        sound.play()
            .then()
            .catch(() => {
                // Пользователь не взаимодействовал со страницей: игнорируем.
            })
    }
}
